import { render, staticRenderFns } from "./UserDashboardAppointmentsBox.vue?vue&type=template&id=5a9a3e2a&scoped=true&"
import script from "./UserDashboardAppointmentsBox.vue?vue&type=script&lang=js&"
export * from "./UserDashboardAppointmentsBox.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardAppointmentsBox.vue?vue&type=style&index=0&id=5a9a3e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a3e2a",
  null
  
)

export default component.exports